import React from 'react';

import { Spinner } from '@admin/components/spinner';

import { AVAILABILITY_TIMES } from './constants';
import { formatHourLabel } from './filters_panel';
import { IAvailabilityUser, IUnavailability } from './types';

const percentage = (value: number) => `${value * 100}%`;

const TimeseriesEntry: React.FC<{
  min: Date;
  max: Date;
}> = ({ min, max }) => {
  const style = {
    left: percentage(0),
    right: percentage(1),
    width: percentage(1),
  };

  return <div className="timeseries-entry availability-none" style={style} />;
};

type DailyViewProps = {
  users: IAvailabilityUser[];
  results: Record<number, IUnavailability[]> | null;
  regionID?: number;
};

export const DailyView: React.FC<DailyViewProps> = ({ users, results, regionID }) => {
  const min = AVAILABILITY_TIMES[0];
  const max = AVAILABILITY_TIMES[AVAILABILITY_TIMES.length - 1];
  const filteredUsers = regionID ? users.filter((user) => user.region_ids.includes(regionID)) : users;

  return (
    <div className="availabilities-daily">
      <div className="panel availabilities-daily">
        <div className="panel-heading">
          <div className="panel-title">Daily View</div>
        </div>

        {results ? (
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th className="col-zero col-nowrap" />
                  {AVAILABILITY_TIMES.map((time) => (
                    <th key={time.getUTCHours()} style={{ width: '5%' }}>
                      {formatHourLabel(time)}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filteredUsers.map((user) => (
                  <tr key={user.id}>
                    <td className="col-zero col-nowrap">{user.name}</td>
                    <td className="col-fill" colSpan={AVAILABILITY_TIMES.length}>
                      <div className="timeseries-container availability-full">
                        {(results[user.id] ?? []).map((entry) => (
                          <TimeseriesEntry key={entry.id ?? `${user.id}-${entry.start_date}`} min={min} max={max} />
                        ))}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="panel-body">
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};
